import { CForm, CFormInput } from "@coreui/react";
import { getToastStore } from "@utils/ToastStore";
import { useSpinner } from "@webkit/components/typescript/SpinnerContext";
import { CARD_INFO_TYPE_ENUM } from "@webkit/enums/CardInfoTypeEnum.enum";
import { t } from "i18next";
import { ChangeEvent, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { base64ToFile, handleDefaultImgClick, successToast } from "@webkit/functions/utils";
import cardInfoService from "@services/cardInfo.service";
import ImageCarousel from "@webkit/components/typescript/DefaultImagesCarousel";

export default function EditCardInfoPage() {

    const ctxToast = getToastStore();
    const [title, setTitle] = useState('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const formData = new FormData();
    const location = useLocation();
    const { showSpinner, hideSpinner } = useSpinner();
    const navigate = useNavigate();
    const isDisabled = (
        !preview ||
        !title
    );
    const [idCardInfo, setIdCardInfo] = useState('');
    const segments = location.pathname.split('/').filter(Boolean);

    useEffect(() => {
        recoverData();
    }, []);

    const recoverData = async () => {

        const idCard = segments.at(2) ?? '';
        setIdCardInfo(idCard);
        const data = await cardInfoService.findCardInfo(idCard);
        setTitle(data.title);
        const base64String = data.cardInfo.photo;
        const dataUrl = `data:image/jpeg;base64,${base64String}`;
        setPreview(dataUrl);
        const file = base64ToFile(dataUrl, "image.jpg");
        setSelectedFile(file);
        //setSelectedFile(base64String);
    };

    // quando l’utente seleziona un file
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        const maxSize = 5 * 1024 * 1024;
        if (file) {
            if (file.type !== "image/jpeg" && file.type !== "image/png" && file.type !== "image/jpg") {
                if (ctxToast) {
                    ctxToast.setToastMsg(t("error.invalid_image_format"));
                    ctxToast.setSeeToast(true);
                    ctxToast.setErrorToast(true);
                }
                e.target.value = "";
                return;
            }
            if (file.size > maxSize) {
                if (ctxToast) {
                    ctxToast.setToastMsg(t("error.too_large"));
                    ctxToast.setSeeToast(true);
                    ctxToast.setErrorToast(true);
                }
                e.target.value = "";
                return;
            }
            setSelectedFile(file)
            // crea un’anteprima temporanea
            const previewUrl = URL.createObjectURL(file)
            setPreview(previewUrl)
            formData.append('img', file);

        }
    }

    const handleSubmit = async () => {
        if (!selectedFile) return

        try {
            showSpinner();

            formData.append('img', selectedFile);

            const IdAccomodation = segments.at(1) ?? '';
            const body = {
                title: title.trim(),
                cardInfo: {
                    type: CARD_INFO_TYPE_ENUM.STANDARD,
                    parentIdCard: null
                }
            };
            const bodyJson = JSON.stringify(body);
            formData.append('body', new Blob([bodyJson], { type: 'application/json' }));
            await cardInfoService.updateCardInfo(IdAccomodation, idCardInfo, formData);
            successToast(ctxToast, t("success.updated"));
            navigate(`/new-app/${IdAccomodation}`);

        } catch (error: any) {
            console.error('errore durante la modifica della card info', error)
        } finally {
            hideSpinner();
        }

    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="card shadow-lg" style={{ width: '60%', borderRadius: '25px' }}>
                <div className="hst-card-header card-header text-uppercase">
                    {t('title.edit_cardinfo')}
                </div>
                <div className="card-body">
                    <CForm className="p-5">
                        <CFormInput
                            type="text"
                            label={`${t('label.icon_name')} ${t('placeholder.obligatory')}`}
                            className="mb-3"
                            value={title}
                            onChange={(e) =>
                                setTitle(e.target.value)
                            }
                        />
                        <p className="my-4">{t('text.default_images')}</p>
                        <ImageCarousel 
                          onImageSelect={(base64, index) => 
                          handleDefaultImgClick(base64, index, setSelectedFile, setPreview, formData)
                        }/>
                        <CFormInput
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        {preview && (
                            <div className="preview-card">
                                <img
                                    src={preview}
                                    alt="Anteprima"
                                    style={{ maxWidth: '200px', height: 'auto' }}
                                />
                            </div>
                        )}
                    </CForm>
                    <div
                        className="card-footer bg-transparent"
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <Button
                            className="hst-btn-secondary"
                            onClick={() => navigate(-1)}
                        >
                            {t('text.go_back')}
                        </Button>

                        <Button
                            className="text-uppercase hst-btn-primary"
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            style={{fontWeight:"500"}}
                        >
                            {t('button.save')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
};